if (!customElements.get('lndu-pdp-video-gallery')) {
  class LnduPdpVideoGallery extends HTMLElement {
    constructor() {
      super()
      this.activeTrigger = null
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-video-tab]'))
      this.cards = Array.from(this.querySelectorAll('[data-video-card]'))
      this.dialog = this.querySelector('[data-video-dialog]')
      this.player = this.querySelector('[data-video-player]')
      this.dialogTitle = this.querySelector('[data-video-dialog-title]')

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectCategory(tab))
      })

      this.querySelectorAll('[data-video-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => this.openVideo(trigger))
      })

      this.querySelector('[data-video-close]')?.addEventListener('click', () => this.dialog?.close())
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close()
      })
      this.dialog?.addEventListener('close', () => this.resetDialog())
    }

    selectCategory(selectedTab) {
      const category = selectedTab.dataset.videoTab

      this.tabs.forEach((tab) => {
        const isSelected = tab === selectedTab
        tab.classList.toggle('is-active', isSelected)
        tab.setAttribute('aria-selected', String(isSelected))
        tab.tabIndex = isSelected ? 0 : -1
      })

      this.cards.forEach((card) => {
        card.hidden = card.dataset.videoCard !== category
      })
    }

    openVideo(trigger) {
      if (!this.dialog || !this.player) return

      const template = this.querySelector(`#${CSS.escape(trigger.dataset.videoTemplate)}`)
      if (!template) return

      this.activeTrigger = trigger
      this.player.replaceChildren(template.content.cloneNode(true))
      if (this.dialogTitle) this.dialogTitle.textContent = trigger.dataset.videoTitle || ''

      this.dialog.showModal()
      document.body.classList.add('lndu-video-dialog-open')

      const video = this.player.querySelector('video')
      if (video) video.play().catch(() => {})
    }

    resetDialog() {
      this.player?.replaceChildren()
      document.body.classList.remove('lndu-video-dialog-open')
      this.activeTrigger?.focus()
      this.activeTrigger = null
    }
  }

  customElements.define('lndu-pdp-video-gallery', LnduPdpVideoGallery)
}
